import http from './http';

export default {
  get() {
    return http().get(`/v1/accounts`);
  },
  provisionAccount(accountId, provisionData) {
    return http().post(`v1/accounts/${accountId}/provision-account`, provisionData);
  },
  billingPortalSession(accountId) {
    return http().get(`/v1/accounts/${accountId}/billing-portal`);
  },
  update(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/accounts/${data.id}`, data);
  },
  changeDefaultContactType(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/accounts/default_seller_contact_type`, data);
  },
  changeEmailDomain(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/accounts/email_domain`, data);
  },
  verifyDomain(validationErrors = {}) {
    return http(validationErrors).put(`/v1/accounts/verify_email_domain`);
  },
  updateDomainProvider(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/accounts/domain_provider`, data);
  },
  updateShareableStore(data, validationErrors = {}) {
    return http(validationErrors).put(`/v1/accounts/${data.id}/shareable_store`, data);
  },
  updateAppointmentSettings(id, data) {
    return http().put(`/v1/accounts/${id}/appointment`, data)
  },
  updateTaskSettings(id, data) {
    return http().put(`/v1/accounts/${id}/tasks/next_contact_at`, data)
  },
  /**
   * Use the route when a user is cancelling there account.  It will make is so that no users can login
   * and all of the accounts data will be deleted in 60 days.  In order to reactivate the account to recover data
   * before the 60 days is up, the customer will have to call support.  Then support will be able to reactivate it
   * and only the first owner will be able to log in at that point.  And the data will not get deleted.
   *
   * Api Request: CancelAccountRequest
   *
   * @param data
   * @returns {Promise<AxiosResponse<any>>}
   */
  delete(data) {
    return http().post(`/v1/accounts`, data);
  },
}
